export enum AppConfigsActionDispatchTypes {
  APP_CONFIG_INVOKE = "APP_CONFIG_INVOKE",
  APP_CONFIG_SUCCESS = "APP_CONFIG_SUCCESS",
}

export enum AppEnvironmentConfig {
  DEV = "development",
  PROD = "production",
}

export enum CloudEnvironmentConfig {
  SB1 = "SB1",
  QA1 = "QA1",
  DEV1 = "DEV1",
  STG = "STG",
  SB2 = "SB2",
  DEV2 = "DEV2",
  QA2 = "QA2"
}

export const Application =  "ConnectUI";

export enum GetConfigVariablesActionDispatchTypes {
  GET_CONFIG_INVOKE = "GET_CONFIG_INVOKE",
  GET_CONFIG_SUCCESS = "GET_CONFIG_SUCCESS",
  GET_CONFIG_ERROR = "GET_CONFIG_ERROR",
}
